var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29609 11.4111C4.03299 11.4111 3.80371 11.2859 3.60826 11.0353L0.191689 6.7533C0.0638963 6.58627 0 6.41924 0 6.25221C0 6.05481 0.062017 5.89347 0.186051 5.7682C0.310085 5.64293 0.469826 5.58029 0.665274 5.58029C0.89079 5.58029 1.08624 5.68659 1.25162 5.89917L4.26226 9.7826L10.1595 0.364428C10.3099 0.121476 10.5091 0 10.7571 0C10.9526 0 11.1104 0.0607386 11.2307 0.182214C11.351 0.30369 11.4111 0.463127 11.4111 0.660525C11.4111 0.812369 11.3548 0.975603 11.242 1.15022L4.97264 11.0353C4.80726 11.2859 4.58174 11.4111 4.29609 11.4111Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTick);
export default __webpack_public_path__ + "static/media/CheckTick.8b186ab75bd958750a29b317770963c4.svg";
export { ForwardRef as ReactComponent };